<div class="row">
  <div class="col-md-6">
    <form [formGroup]="settingsForm">
      <mat-form-field2 matTooltip="Your balance will be recharged when you hit this amount" matTooltipPosition="above">
        <mat-label i18n>Auto recharge when balance goes below ($)</mat-label>
        <input type="number" matInput formControlName="recharge_threshold" />
        <mat-error
          *ngIf="
            settingsForm.get('recharge_threshold').hasError('required') &&
            settingsForm.get('recharge_threshold').touched
          "
        >
          <ng-container i18n>Value is required</ng-container>
        </mat-error>
        <mat-error *ngIf="settingsForm.get('recharge_threshold').hasError('positive')">
          <ng-container i18n>Value should be greater than 0</ng-container>
        </mat-error>
      </mat-form-field2>
      <mat-form-field2
        i18n-matTooltip
        matTooltip="This amount will be your actual credit/balance after recharge"
        matTooltipPosition="above"
      >
        <mat-label i18n>Bring balance back up to ($)</mat-label>
        <input type="number" matInput formControlName="recharge_balance" />
        <mat-error
          *ngIf="
            settingsForm.get('recharge_balance').hasError('required') && settingsForm.get('recharge_balance').touched
          "
        >
          <ng-container i18n>Value is required</ng-container>
        </mat-error>
        <mat-error *ngIf="settingsForm.get('recharge_balance').hasError('positive')">
          <ng-container i18n>Value should be greater than 0</ng-container>
        </mat-error>
      </mat-form-field2>
      <div class="alert alert-secondary-warning" i18n>Note: Messaging credit deduction may vary due to location.</div>

      <div class="d-flex">
        <button class="btn btn-secondary-info ml-auto" (click)="onSave(settingsForm)">
          <i class="fa fa-save"></i> <ng-container i18n>Save</ng-container>
        </button>
      </div>
    </form>
  </div>
  <div class="col-md-6 border-left">
    <form [formGroup]="rechargeForm">
      <mat-form-field2
        matTooltip="Your balance will be increased immediately"
        i18n-matTooltip
        matTooltipPosition="above"
      >
        <mat-label><ng-container i18n>Instant Recharge</ng-container> ($)</mat-label>
        <input type="number" matInput formControlName="recharge_amount" required />
        <mat-error
          *ngIf="
            rechargeForm.get('recharge_amount').hasError('required') && rechargeForm.get('recharge_amount').touched
          "
        >
          <ng-container i18n>Value is required</ng-container>
        </mat-error>
        <mat-error *ngIf="rechargeForm.get('recharge_amount').hasError('positive')">
          <ng-container i18n>Value should be greater than 0</ng-container>
        </mat-error>
        <mat-error *ngIf="rechargeForm.get('recharge_amount').hasError('min')">
          <ng-container i18n>Value should be greater than 5</ng-container>
        </mat-error>
      </mat-form-field2>

      <div class="d-flex">
        <button [disabled]="isRecharging" class="btn btn-secondary-info ml-auto" (click)="onCharge(rechargeForm)">
          <i class="fa fa-save"></i> <ng-container i18n>Recharge</ng-container>
        </button>
      </div>
    </form>
  </div>
</div>
